import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMsgSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      d="M12.5 7.382a1.494 1.494 0 0 0-1.7-.209V7H10v5h1V8.5a.5.5 0 0 1 1 0V12h1V8.5a.5.5 0 0 1 1 0V12h1V8.41l-.003-.002A1.5 1.5 0 0 0 12.5 7.382ZM19 10.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H16v-1h1.45c.18 0 .317-.037.41-.11a.423.423 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H19v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 11.8c-.207.133-.457.2-.75.2h-.55c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H24v6a1 1 0 0 1-1 1h-2.5v-1H22c.84 0 1 0 1-1v-.2Zm-.65-.8c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V8h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 19h18v12H8V19Zm1 1.707v8.586L13.293 25 9 20.707Zm5 5L9.707 30h14.586L20 25.707l-3 3-3-3ZM20.707 25 25 29.293v-8.586L20.707 25Zm3.586-5H9.707L17 27.293 24.293 20Z"
      fill="#fff"
      opacity={0.6}
    />
  </svg>
);
export default FileIconMsgSizeM;
